import { render, staticRenderFns } from "./Sheet_together.vue?vue&type=template&id=5a4e8c5a&scoped=true"
import script from "./Sheet_together.vue?vue&type=script&lang=js"
export * from "./Sheet_together.vue?vue&type=script&lang=js"
import style0 from "./Sheet_together.vue?vue&type=style&index=0&id=5a4e8c5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4e8c5a",
  null
  
)

export default component.exports